export const Monogram = ({ size = 40 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    aria-hidden="true"
  >
    <circle cx="32" cy="32" r="30.5" stroke="currentColor" strokeWidth="1" opacity=".55" />
    <path d="M19 18.5 h4.5 a13.5 13.5 0 0 1 0 27 H19 Z" fill="none" stroke="currentColor" strokeWidth="2.2" />
    <path d="M32.5 18.5 h4.5 a13.5 13.5 0 0 1 0 27 h-4.5 Z" fill="none" stroke="currentColor" strokeWidth="2.2" opacity=".65" />
  </svg>
);

export default Monogram;
